module.exports = __webpack_public_path__ + "static/media/IconQuestion.6446af0b.svg";